import { render, staticRenderFns } from "./DistributionWay.vue?vue&type=template&id=4cea5c04&scoped=true&"
import script from "./DistributionWay.vue?vue&type=script&lang=ts&"
export * from "./DistributionWay.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionWay.vue?vue&type=style&index=0&id=4cea5c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea5c04",
  null
  
)

export default component.exports